import {
	ActivateContainerConfigMutation,
	DeactivateContainerConfigMutation,
	MergeContainerConfigMutation
} from "~/gql/mutations/containers.generated";
import {
	CancelErpLoadListSessionMutation,
	CreateErpLoadListSessionMutation,
	DeleteErpLoadListSessionMutation,
	ProcessErpLoadListSessionMutation,
	SubmitErpLoadListSessionMutation,
	UpdateErpLoadListQuantitiesMutation,
	UpdateErpLoadListSessionItemAvailabilityMutation,
	UpdateErpLoadListSessionNameMutation,
	UpdateErpLoadListSessionRoutesMutation,
	UpdateErpLoadListSessionShipDateMutation
} from "~/gql/mutations/restock/loadList.generated";
import {
	GetAllContainerConfigsQuery,
	GetErpFinishAvailabilityQuery,
	GetErpLoadListAvailabilityQuery,
	GetErpLoadListQuantitiesQuery,
	GetErpLoadListSessionQuery,
	GetErpLoadListSessionsQuery,
	GetErpLoadListUsersQuery,
	GetErpStationRoutesQuery,
	GetErpStationsQuery,
	GetLoadListItemIdsQuery
} from "~/gql/queries/restock/loadList.generated";

export const loadListEndpoints = {
	ActivateContainerConfig: {
		invalidatesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: ActivateContainerConfigMutation) => res
	},
	CancelErpLoadListSession: {
		invalidatesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: CancelErpLoadListSessionMutation) => res
	},
	CreateErpLoadListSession: {
		invalidatesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: CreateErpLoadListSessionMutation) => res
	},
	DeactivateContainerConfig: {
		invalidatesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: DeactivateContainerConfigMutation) => res
	},
	DeleteErpLoadListSession: {
		invalidatesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: DeleteErpLoadListSessionMutation) => res
	},
	GetAllContainerConfigs: {
		providesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: GetAllContainerConfigsQuery) => res
	},
	GetErpFinishAvailability: {
		providesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: GetErpFinishAvailabilityQuery) => res
	},
	GetErpLoadListAvailability: {
		providesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: GetErpLoadListAvailabilityQuery) => res
	},
	GetErpLoadListQuantities: {
		providesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: GetErpLoadListQuantitiesQuery) => res
	},
	GetErpLoadListSession: {
		providesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: GetErpLoadListSessionQuery) => res
	},
	GetErpLoadListSessions: {
		providesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: GetErpLoadListSessionsQuery) => res
	},
	GetErpLoadListUsers: {
		providesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: GetErpLoadListUsersQuery) => res
	},
	GetErpStationRoutes: {
		providesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: GetErpStationRoutesQuery) => res
	},
	GetErpStations: {
		providesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: GetErpStationsQuery) => res
	},
	GetLoadListItemIds: {
		providesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: GetLoadListItemIdsQuery) => res
	},
	MergeContainerConfig: {
		invalidatesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: MergeContainerConfigMutation) => res
	},
	ProcessErpLoadListSession: {
		invalidatesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: ProcessErpLoadListSessionMutation) => res
	},
	SubmitErpLoadListSession: {
		invalidatesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: SubmitErpLoadListSessionMutation) => res
	},
	UpdateErpLoadListQuantities: {
		// No invalidatesTags — the mutation response already returns the updated session state,
		// which sendBatchUpdate dispatches directly via setCurrentSession(updatedSession).
		// Invalidating "LoadList" triggers a redundant refetch that causes AG Grid to receive
		// new row data while a cell is being edited, committing the in-progress edit via
		// valueSetter and re-adding to pendingUpdates — restarting the mutation loop.
		transformResponse: (res: UpdateErpLoadListQuantitiesMutation) => res
	},
	UpdateErpLoadListSessionItemAvailability: {
		invalidatesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: UpdateErpLoadListSessionItemAvailabilityMutation) => res
	},
	UpdateErpLoadListSessionName: {
		invalidatesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: UpdateErpLoadListSessionNameMutation) => res
	},
	UpdateErpLoadListSessionRoutes: {
		invalidatesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: UpdateErpLoadListSessionRoutesMutation) => res
	},
	UpdateErpLoadListSessionShipDate: {
		invalidatesTags: ["LoadList"] as AddTagTypes,
		transformResponse: (res: UpdateErpLoadListSessionShipDateMutation) => res
	}
};
